import { useState, useEffect } from 'react';

const useVisitedUrls = () => {
  const [visitedUrls, setVisitedUrls] = useState<string[]>([]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Load initial visited URLs from local storage
      const storedUrls = localStorage.getItem('visitedUrls');
      if (storedUrls) {
        setVisitedUrls(JSON.parse(storedUrls));
      }

      // Add the current URL on initial load
      addUrlToHistory(window.location.href);

      // Wrap pushState and replaceState to capture internal navigation
      const originalPushState = window.history.pushState;
      const originalReplaceState = window.history.replaceState;

      window.history.pushState = function (...args) {
        originalPushState.apply(window.history, args);
        addUrlToHistory(window.location.href);
      };

      window.history.replaceState = function (...args) {
        originalReplaceState.apply(window.history, args);
        addUrlToHistory(window.location.href);
      };

      // Capture browser back/forward actions (popstate)
      const handlePopState = () => {
        addUrlToHistory(window.location.href);
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        // Clean up on unmount
        window.history.pushState = originalPushState;
        window.history.replaceState = originalReplaceState;
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, []);

  const addUrlToHistory = (url: string) => {
    setVisitedUrls(prevUrls => {
      const newUrls = [url, ...prevUrls];
      // Keep only the last 20 URLs
      const limitedUrls = newUrls.slice(0, 19);
      // Save updated URLs to local storage
      localStorage.setItem('visitedUrls', JSON.stringify(limitedUrls));
      return limitedUrls;
    });
  };

  return visitedUrls;
};

export default useVisitedUrls;
